import React, { memo } from "react";

import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import { Row } from "components/Layout";
import LoadingSpinner from "components/LoadingSpinner";
import { StatusText } from "components/Text";

import { selectBiddersList } from "selectors";

import { BuyerCard } from "./BuyerCard";

const Wrapper = styled(Row)`
  flex-wrap: wrap;
  margin: 9px;
`;

function RegisteredBidder(props) {
  const { onSelectBidder, registrationNumber, hasWarning, id } = props;
  function onClick() {
    onSelectBidder(id);
  }
  return (
    <BuyerCard isTopBuyer data-tour={registrationNumber} onClick={onClick}>
      <div>
        {registrationNumber}&nbsp;
        {hasWarning && <StatusText status="warning" />}
      </div>
    </BuyerCard>
  );
}

function RegisteredBidderGrid({ onSelectBidder, filter }) {
  const allBidders = useSelector(selectBiddersList);
  const loadingBidders = useSelector(
    state => state.bidderRegistrations.isFetching,
  );

  const bidders = allBidders
    .filter(
      bidder =>
        bidder.businessId &&
        (bidder.registrationNumber.toString().indexOf(filter) > -1 || !filter),
    )
    .map(({ defaultPropertyId, id, registrationNumber }) => ({
      id,
      registrationNumber,
      hasWarning: !defaultPropertyId,
    }))
    .sort((a, b) => a.registrationNumber - b.registrationNumber);

  if (loadingBidders) {
    return (
      <Wrapper>
        <LoadingSpinner size={14} subjectName="bidders" />
      </Wrapper>
    );
  }

  if (!bidders.length) {
    if (filter) {
      return <Wrapper>No bidders match &quot;{filter}&quot;.</Wrapper>;
    }
    return <Wrapper>No bidders are registered for this sale.</Wrapper>;
  }

  return (
    <Wrapper>
      {bidders.map(bidder => (
        <RegisteredBidder
          key={bidder.id}
          onSelectBidder={onSelectBidder}
          registrationNumber={bidder.registrationNumber}
          hasWarning={bidder.hasWarning}
          id={bidder.id}
        />
      ))}
    </Wrapper>
  );
}

export default memo(RegisteredBidderGrid);
